export function telefone(value) {
  let temp = value;
  temp = temp.replace(/\D/g, "");
  if (temp.length < 11) {
    temp = temp.replace(/(\d{6})(\d{4})/, "$1-$2");
  } else {
    temp = temp.replace(/(\d{7})(\d{4})/, "$1-$2");
  }
  temp = temp.replace(/^(\d{2})(\d)/, "($1) $2");
  return temp;
}

export function mascaraCNPJ(cnpj) {
  cnpj = cnpj.replace(/\D/g, '');

  cnpj = cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");

  return cnpj;
}

export function mascaraNumeroGuia(valor) {
  valor = valor?.replace(/\D/g, '');

  if (valor.length > 13) {
    valor = valor?.slice(0, 15);
    valor = valor?.replace(/^(\d{13})(\d{0,2})/, '$1-$2');
  }

  return valor;
}



export function formatNumeroProcesso(value) {
  let temp = value;
  temp = temp.replace(/\D/g, "");
  temp = temp.slice(0, 20);


  temp = temp.replace(/^(\d{7})(\d{2})?(\d{4})?(\d)?(\d{2})?(\d{4})?(\d)?(\d{2})?(\d{4})?$/, (_, g1, g2, g3, g4, g5, g6, g7, g8, g9) => {
    let result = g1;
    if (g2) result += `-${g2}`;
    if (g3) result += `.${g3}`;
    if (g4) result += `.${g4}`;
    if (g5) result += `.${g5}`;
    if (g6) result += `.${g6}`;
    if (g7) result += `.${g7}`;
    if (g8) result += `.${g8}`;
    if (g9) result += `.${g9}`;
    return result;
  });

  return temp;
}




export function numeroProcesso(value) {
  let temp = value;
  temp = temp.replace(/\D/g, "");
  temp = temp.slice(0, 20);


  temp = temp.replace(/^(\d{7})(\d{2})?(\d{4})?(\d)?(\d{2})?(\d{4})?(\d)?(\d{2})?(\d{4})?$/, (_, g1, g2, g3, g4, g5, g6, g7, g8, g9) => {
    let result = g1;
    if (g2) result += `-${g2}`;
    if (g3) result += `.${g3}`;
    if (g4) result += `.${g4}`;
    if (g5) result += `.${g5}`;
    if (g6) result += `.${g6}`;
    if (g7) result += `.${g7}`;
    if (g8) result += `.${g8}`;
    if (g9) result += `.${g9}`;
    return result;
  });

  return temp;
}

export function normalizeString(str) {
  if (str) {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  } else {
    return ""
  }

}

export function certidaoNascimento(value) {
  let temp = value;
  temp = temp.replace(/\D/g, "");


  temp = temp.replace(/^(\d{6})(\d{2})?(\d{2})?(\d{4})?(\d)?(\d{5})?(\d{3})?(\d{7})?(\d{2})?$/, (_, g1, g2, g3, g4, g5, g6, g7, g8, g9) => {
    let result = g1;
    if (g2) result += ` ${g2}`;
    if (g3) result += ` ${g3}`;
    if (g4) result += ` ${g4}`;
    if (g5) result += ` ${g5}`;
    if (g6) result += ` ${g6}`;
    if (g7) result += ` ${g7}`;
    if (g8) result += ` ${g8}`;
    if (g9) result += ` ${g9}`;
    return result;
  });

  return temp;
}


export function cpf(value) {
  let temp = value;
  temp = temp.replace(/\D/g, "");
  temp = temp.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  return temp;
}

export function cep(value) {
  let temp = String(value).replace(/\D/g, ""); // Remove caracteres não numéricos

  if (temp.length > 5) {
    temp = temp.replace(/(\d{5})(\d{1,3})/, "$1-$2"); // Formata parcialmente
  }

  return temp;
}

export function numeroInscricaoPGEA(value) {
  let temp = value;
  temp = temp.replace(/[^0-9./-]+/, "");
  return temp;
}

export function numerosRegularidade(value) {
  let temp = value;
  temp = temp.replace(/[^0-9./-]/g, "");
  return temp;
}

export function numeroEndereco(value) {
  let temp = value;
  temp = temp.replace(/[^0-9]/g, "");
  return temp;
}

export function onlyNumbers(value) {
  let temp = value;
  temp = temp.replace(/[^0-9]+/, "");
  return temp;
}

export function onlyLettters(value) {
  let temp = value;
  temp = temp.replace(/[^a-zA-Z- ]+/g, "");
  return temp;
}

export function forNames(value) {
  let temp = value;
  temp = temp.replace(/[^A-Za-zÀ-ÿ\s]+/g, "");
  return temp;
}

export function hoursMinutes(value) {
  let temp = value;

  temp = temp.replace(/(\d{2})(\d)/, "$1:$2")
    .replace(/[^\dh:]/, "")
    .replace(/^[^0-2]/, "")
    .replace(/^([2-9])[4-9]/, "$1")
    .replace(/^\d[:h]/, "")
    .replace(/^([01][0-9])[^:h]/, "$1")
    .replace(/^(2[0-3])[^:h]/, "$1")
    .replace(/^(\d{2}[:h])[^0-5]/, "$1")
    .replace(/^(\d{2}h)./, "$1")
    .replace(/^(\d{2}:[0-5])[^0-9]/, "$1")
    .replace(/^(\d{2}:\d[0-9])./, "$1")

  return temp;
}